import {applyMiddleware, compose, createStore} from "redux";
import allReducers from "../redux/reducers";
import thunk from "redux-thunk";

export const store = createStore(
    allReducers, compose(applyMiddleware(thunk))
)


